import { Constants } from '@shared/ui-components';

import { ReducerMethods } from 'common/interfaces/reducer-methods';
import { MonoliteHelper } from 'common/monolite';
import { ThemeToneInterface, ThemeType } from '../../components/theme-provider/interfaces';
import { PersistedStorageActionTypes } from './actions/types';
import { PersistedStorageState } from './interfaces/state';

export const PersistedStorageReducerMethods: ReducerMethods<PersistedStorageState> = {
  [PersistedStorageActionTypes.SET_THEME]: (s, payload: ThemeType) => {
    return new MonoliteHelper(s)
      .set(_ => _.theme, payload)
      .get();
  },
  [PersistedStorageActionTypes.SET_THEME_TONE]: (s, payload: ThemeToneInterface) => {
    const stateUpdater = new MonoliteHelper(s);
    payload.theme === Constants.Theme.DARK_THEME.name
      ? stateUpdater.set(_ => _.darkTone, payload.tone)
      : stateUpdater.set(_ => _.lightTone, payload.tone);
    return stateUpdater.get();
  },
  [PersistedStorageActionTypes.SET_SELECTED_COMPANY_ID]: (s, payload: number) => {
    return new MonoliteHelper(s)
      .set(_ => _.selectedCompanyId, payload)
      .get();
  },
};
